import { useMutation } from "@tanstack/react-query";
import { createSchedule } from "@coworker/apprestructured/src/task-management/services/schedules.service";
import { CreateSchedule } from "@coworker/apprestructured/src/task-management/types/Schedule";

export const useCreateSchedule = () => {
  return useMutation({
    mutationFn: (schedule: CreateSchedule) => createSchedule(schedule),
  });
};
